var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriggerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DE1186",
    points: "269.353,341.164 150.303,361.694 170.833,242.644 250.66,252.254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M503.493,8.504l-146.833,195l-120.737,72.57c-4.895-2.514-197.894-101.625-198-101.68L503.493,8.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M503.493,8.504l-165.89,465.57c-0.07-0.136-101.508-197.665-101.68-198L503.493,8.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M134.202,377.795c-2.93-2.928-7.678-2.928-10.607,0L27.271,474.12c-2.929,2.93-2.929,7.678,0,10.607       c2.931,2.929,7.678,2.928,10.607,0l96.324-96.324C137.131,385.473,137.131,380.725,134.202,377.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M147.676,450.039l-48.162,48.162c-2.929,2.93-2.929,7.678,0,10.607c2.931,2.929,7.678,2.928,10.607,0       l48.162-48.162c2.929-2.93,2.929-7.678,0-10.607C155.354,447.111,150.606,447.111,147.676,450.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M61.959,353.714c-2.93-2.928-7.678-2.928-10.607,0L3.19,401.876c-2.929,2.93-2.929,7.678,0,10.607       c2.931,2.929,7.678,2.928,10.607,0l48.162-48.162C64.888,361.392,64.888,356.644,61.959,353.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE1186",
    d: "M500.976,1.44L35.408,167.331c-2.817,1.004-4.768,3.585-4.966,6.569c-0.197,2.984,1.396,5.801,4.058,7.167       L162.505,246.8l-19.592,113.619c-0.879,5.095,3.555,9.546,8.665,8.665l113.619-19.592l65.732,128.005       c1.388,2.704,4.251,4.263,7.167,4.058c2.984-0.197,5.565-2.149,6.569-4.966L510.558,11.022       C512.696,4.987,506.819-0.65,500.976,1.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerIcon);
export default __webpack_public_path__ + "static/media/trigger-icon.b7522c8b9747b434c38bbe27bd5c35c3.svg";
export { ForwardRef as ReactComponent };